import React from "react";

export default function GlobalErrorFallback({ error, resetErrorBoundary }) {
    const isDev = true;

    if (isDev) {
        return (
            <div style={{ padding: 20 }}>
                <h1>💥 Ошибка приложения</h1>
                <pre style={{ whiteSpace: "pre-wrap" }}>
                    {error?.stack || error?.message}
                </pre>
                <button onClick={resetErrorBoundary}>Reload</button>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
                <h2 className="text-2xl font-bold mb-4">Internal error</h2>
                <p className="text-gray-600 mb-6">Произошла непредвиденная ошибка</p>
                <button
                    onClick={() => window.location.reload()}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
                >
                    Перезагрузить приложение
                </button>
            </div>
        </div>
    );
}
